<script lang="ts">
	//UI
	import { Card, Linkicon, InlineButton } from "@hitit/new_ui";
	//Utils
	//Types
	//Props
	export let item: any;
	//Constants
	//Variables
	let copyTimeout: any;
	let copyStatus: string = "normal";
	//Functions
	function copy(link: string) {
		try {
			if (copyTimeout) clearTimeout(copyTimeout);
			navigator.clipboard.writeText(link);
			copyStatus = "success";
		} catch (e) {
		} finally {
			copyTimeout = setTimeout(() => (copyStatus = "normal"), 2000);
		}
	}
	//Do
</script>

<Card noPadding -faqreader>
	<div class="container" id="FAQ-detailviewer">
		<div class="header">
			<span class="displaysort"> {item.displaySort} </span>
			<div class="link-status">
				{#if item.getLink()}
					<InlineButton on:click={() => copy(item.getLink())}>
						<span class="link">
							<span class="icon">
								<Linkicon />
							</span>
							{copyStatus === "normal" ? "링크 복사하기" : "복사 완료"}
						</span>
					</InlineButton>
				{/if}
				<div class="status">
					<div
						class="icon"
						class:publish={item.documentState === "PUBLISHED"}
						class:obsolate={item.documentState === "OBSOLETE"}
					/>
					<p>{item.documentState}</p>
				</div>
			</div>
		</div>
		<div class="title-values">
			<div class="title-value">
				<span class="title"> 질문 </span>
				<div class="value question">{item.question}</div>
			</div>
			<div class="title-value">
				<span class="title"> 답변 </span>
				<div class="value answer" id="HITIT-wiswig">
					{@html item.answer}
				</div>
			</div>
		</div>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";
	:global(.-faqreader) {
		overflow-y: auto;
	}
	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: max-content;
		padding: 20px 10px;
		gap: 20px;
		overflow-y: auto;
		.header {
			display: flex;
			justify-content: space-between;
			.displaysort {
				color: #46474b;
				font-weight: 500;
				font-size: 1.25rem;
			}

			.link-status {
				display: flex;
				align-items: center;
				gap: 20px;
			}
			.link {
				.icon {
					width: 14px;
					height: 14px;
					display: flex;
				}
				font-weight: 200;
				color: #3c68d6;
				display: flex;
				align-items: center;
				gap: 5px;
				padding-bottom: 1px;
				border-bottom: 1px solid #3c68d6;
			}

			.status {
				display: flex;
				align-items: center;
				gap: 10px;
				color: #46474b;
				font-weight: 200;
				.icon {
					width: 15px;
					height: 15px;
					border-radius: 15px;
					background-color: #bcbfc3;

					&.publish {
						background-color: #44e4ae;
					}

					&.obsolate {
						background-color: #ffce00;
					}
				}
			}
		}
		.title-values {
			display: flex;
			flex-direction: column;
			gap: 20px;

			.title-value {
				display: flex;
				flex-direction: column;
				gap: 10px;

				.title {
					font-size: 0.875rem;
					font-weight: 200;
					color: #6d6f76;
				}
				.question {
					font-weight: 500;
					color: #46474b;
				}
			}
		}
		.answer {
			padding: 20px 10px;
			border: 1px solid #d3d4da;
			border-radius: 5px;
		}
	}
	@include DesktopSize {
		.container {
			padding: 30px;
			.title-values {
				.title-value {
					.title {
						font-size: 1rem;
					}
					.question {
						font-size: 1.25rem;
					}
				}
			}
			.header {
				.status {
					gap: 7px;
					font-size: 1.25rem;
					p {
						margin-top: -2px;
					}
					.icon {
						width: 20px;
						height: 20px;
					}
				}
				.displaysort {
					font-size: 1.5rem;
				}
			}

			.answer {
				padding: 20px 20px;
			}
		}
	}
</style>
